/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "clearance",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fillRule": "evenodd",
                "clipRule": "evenodd",
                "fill": "#367C2B"
            },
            "clearance": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "19.3",
            "height": "23"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19.3 23", className: "clearance", width: this.props.width, height: this.props.height, style: this.props.clearance },
            _react2["default"].createElement("path", { className: "st0", d: "M19.3 10.6V3.3l-2.6-1.6L13.9 0 7.4 3.3c-.5.3-.5.4-.6.6L.3 14.5c-.6 1-.3 2.2.7 2.8L5.3 20l4.5 2.7c.9.6 2.2.3 2.8-.7l6.5-10.6c.1-.2.2-.3.2-.8zm-5.7-4c-.9-.6-1.2-1.8-.6-2.7.6-.9 1.7-1.2 2.7-.6.9.6 1.2 1.7.6 2.7-.6.8-1.8 1.1-2.7.6z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/clearance.js